import React from "react";

export default function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* Clean checkmark icon - represents tracking success */}
      <div style={{
        width: "34px",
        height: "34px",
        borderRadius: "10px",
        background: "linear-gradient(135deg, #5B5FEE, #4A90E2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontWeight: "bold",
        fontSize: "18px",
        flexShrink: 0
      }}>
        ✓
      </div>
      <span style={{ 
        fontWeight: 600, 
        fontSize: "16px",
        color: "#111827",
        whiteSpace: "nowrap"
      }}>
        USCIS Tracker
      </span>
    </div>
  );
}
